import { PrimaryButton } from "@digipost/dds-buttons-react";
import Cookies from "js-cookie";
import { FC, MouseEvent } from "react";

import {
  SiteImproveActions,
  SiteImproveCategories,
  siteImproveEvent,
} from "../analytics/SiteImprove";
import Translated from "../infrastructure/Translated";

const IS_PROD = process.env.NODE_ENV === "production";

const GoToDigipostLogInButton: FC = () => {
  return (
    <PrimaryButton
      type="button"
      onClick={(event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        siteImproveEvent({
          category: SiteImproveCategories.REDIRECT,
          action: SiteImproveActions.POST,
          label: "/org/enkeltutsendelse",
        });

        Cookies.set("digipost.target.app", "post", {
          path: "/",
          expires: 1,
          secure: IS_PROD,
        });

        Cookies.set("digipost.target.href", "/org/enkeltutsendelse", {
          path: "/",
          expires: 1,
          secure: IS_PROD,
        });

        window.location.href = "/virksomhetsadmin/";
      }}
    >
      <Translated textKey="register.complete_signering" />
    </PrimaryButton>
  );
};

export default GoToDigipostLogInButton;
